 <sm-misc-title-bar [headerCustomTemplate]="addButton" pageTitle='Targets' [showBackButton]="false">
  <ng-template #addButton>
    <div class="d-flex search-field">
      <button
      mat-icon-button
      mat-dialog-close
      class="align-self-end"
      color="accent">
      <mat-icon style=" color: #000; position: relative; top: -5px;">close</mat-icon>
    </button>
    </div>
  </ng-template>
</sm-misc-title-bar>

 <mat-dialog-content>
    <div class="row" *ngIf="targetList.length > 0 && !isloader">
        <div class="col-sm-4" *ngFor="let item of targetList">
            <div class="fl_orders" (click)="selectTarget(item)">
                <div class="top_section_order">
                    <div class="fill_flexcr">
                    <div class="target_flex">
                        <div class="target_list_profile">
                            <div class="ads_sec">
                                <div class="hm_icon_progr">
                                    <img [src]="item.image_thumb_url" onerror="this.src='../../../../../assets/images/user-avatar.svg'">
                                </div>
                            </div>
                        </div>
                        <div class="normalt_uopwer">
                            <div class="order_dec">
                                <h3 style="-webkit-box-orient: vertical;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;"> {{ item.name ? item.name : item.customer_name}}</h3>
                                <p>{{ item.country_code ? item.country_code : item.customer_country_code }} {{ item.phone ? item.phone : item.customer_phone }}</p>
                             </div>
                        </div>
                    </div>

                       <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                           <mat-icon class="material-icons-outlined" class="mb-1">check</mat-icon>
                         </div>
</div>
                </div>
            </div>
        </div>

    </div>
     <div style="text-align: center;padding-top: 16px;display: flex;justify-content: center;" *ngIf="datalength > targetList.length">
          <button class="see_more_btn" mat-flat-buttoncolor="accent" [disabled]="loader" (click)="seeMore()"><span *ngIf="!loader">See more</span> <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner></button>
    </div>
    <div
    class="row"
    *ngIf="targetList.length == 0 && !isloader"
    style="text-align: center; padding-top: 50px; padding-bottom: 50px"
  >
    <div class="product_svgh">
      <svg fill="#b3b3b3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve" stroke="#b3b3b3"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <ellipse cx="41.3" cy="42.3" rx="12.2" ry="13.5"></ellipse> <path d="M52.6,57.4c-3.1,2.8-7,4.5-11.3,4.5c-4.3,0-8.3-1.7-11.3-4.6c-5.5,2.5-11,5.7-11,10.7v2.1 c0,2.5,2,4.5,4.5,4.5h35.7c2.5,0,4.5-2,4.5-4.5v-2.1C63.6,63,58.2,59.9,52.6,57.4z"></path> <path d="M68,47.4c-0.2-0.1-0.3-0.2-0.5-0.3c-0.4-0.2-0.9-0.2-1.3,0.1c-2.1,1.3-4.6,2.1-7.2,2.1c-0.3,0-0.7,0-1,0 c-0.5,1.3-1,2.6-1.7,3.7c0.4,0.2,0.9,0.3,1.4,0.6c5.7,2.5,9.7,5.6,12.5,9.8H75c2.2,0,4-1.8,4-4v-1.9C79,52.6,73.3,49.6,68,47.4z"></path> <path d="M66.9,34.2c0-4.9-3.6-8.9-7.9-8.9c-2.2,0-4.1,1-5.6,2.5c3.5,3.6,5.7,8.7,5.7,14.4c0,0.3,0,0.5,0,0.8 C63.4,43,66.9,39.1,66.9,34.2z"></path> </g></svg>
    </div>
    <div class="product_placeholder_heading">
      <h3>No {{this.parentdata.type}}s found for this business.</h3>
      <!-- <p>To add a product for selling you need to add that first in your inventory. Go to Inventory section and add one.</p> -->
    </div>
  </div>
  </mat-dialog-content> 

  <mat-dialog-actions align="end" *ngIf="targetList.length > 0">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
    [disabled]="selectedTargets.length == 0"
    (click)="onpost()"
      mat-flat-button
      color="accent">
      Save
    </button>
  </mat-dialog-actions>
  
